import { render } from "./WalletActity.vue?vue&type=template&id=2b9a5250&scoped=true"
import script from "./WalletActity.vue?vue&type=script&lang=js"
export * from "./WalletActity.vue?vue&type=script&lang=js"

import "./WalletActity.vue?vue&type=style&index=0&id=2b9a5250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9a5250"]])

export default __exports__